import { FC, useEffect, useRef, useState } from "react";
import { Accordion } from "../../../../components/controls/accordion";
import GridWrapper from "../../../../components/controls/GridWrapper";
import { DateInput, TextAreaInput, TextInput } from "../../../../components/controls/inputs";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import styles from "../../../styles/index.module.scss";
import createMovementsStyles from "./styles/CreateMovements.module.scss";
import { v4 as uuidv4, NIL as uuidNull } from "uuid";
import GridSelectorInput from "../../../../components/controls/GridSelectorInput";
import { ICostInfoDTO, IEntitySimpleDTO, ISummaryCostInfoDTO } from "../../../../libs/coreapi-dto/@types/common";
import { CheckBox } from "../../../../components/controls/checkbox";
import BaseDocumentCreator from "../../../../components/documents/baseDocumentCreator";
import { DateTime } from "luxon";
import { IMovementItemCreateDTO, IMovementItemEditDTO, IMovementItemGetDTO } from "../../../../libs/coreapi-dto/documents/movementItem";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../../system/hooks/useForm";
import { LotsSelectorModal } from "../../../Accounting/Lots";
import KizScanModal from "../../../Dictionaries/Kiz/ScanModal/KizScanModal";
import { IMovementCreateDTO, IMovementGetDTO, IMovementUpdateDTO } from "../../../../libs/coreapi-dto/documents/movement";
import { MovementCreatorItemModal } from "./MovementCreatorItem/MovementCreatorItemModal";
import { DocumentKey, IDocumentUpdateFormProps } from "../../../../@types/documents";
import { ILotDTO, ILotViewDTO } from "../../../../libs/coreapi-dto/accounting/lot";
import { LotDataProvider } from "../../../../Services/DataProviders/LotDataProvider";
import { StoreDataProvider } from "../../../../Services/DataProviders/StoreDataProvider";
import { IKeyValuePair } from "../../../Reports/Shared/Interfaces/IKeyValuePair";
import { MovementUpdateItemModal } from "./MovementCreatorItem/MovementUpdateItemModal";
import { IOption, Select } from "../../../../components/selects/select";
import { DocumentType, IdTableVariant, SearchOption } from "../../../../@types/enumsGlobal";
import { ILotByIdDTO, ILotsByIdDTO } from "../../../../libs/core-api-requests/accounting/lotRequest";
import LotsSimpleSelectorModal from "../../../../Business/Accounting/Lots/LotsSimpleSelectorModal";
import PositionEditPanel from "../../../../components/commandsPanels/PositionEditPanel";
import { IScalingRatioDTO } from "../../../../libs/coreapi-dto/dirs/scalingRatio";
import { ScalingRatioDataProvider } from "../../../../Services/DataProviders/ScalingRatioDataProvider";
import { BtSaveOrOk } from "../../Invoice/InvoiceCreator/InvoiceUpdateForm";
import { MessageModalWindow } from "../../../../components/modalWindows/MessageModalWindow";
import { getStyleCell } from "../../../../system/functions/getStyleCell";
import { controlKiz, countKizSum } from "../../../../system/functions/controlKiz";
import { addKizOrKizBox } from "../../../../system/functions/addKizOrKizBox";
import renderGlobalAlert from "../../../../system/hooks/useGlobalAlert";
import { KizDataProvider } from "../../../../Services/DataProviders/KizDataProvider";
import { BarcodeType, IKizBoxDTO, IKizDTO } from "../../../../libs/coreapi-dto/dirs/kiz";
import { ChangeableGrid, IChangeDataGrid } from "../../../../components/grids/changeableGrid/ChangeableGrid";
import { addValueToArray } from "../../../../system/functions/addValToArray";
import Tooltip from "../../../../components/tooltips/Tooltip";
import { ActRevaluationButton, StockBalanceButtonCompress, StockBalanceButtonExpand } from "../../../../components/buttons/iconButtons/special/QuickAccessBarCollection";
import { MoneyFormatComponent } from "../../../../components/controls/inputs/BaseInput";
import MovementItemsGridPluginSettings from "../MovementItems/MovementItemsGridPluginSettings";
import useOperativeReserve from "../../../../components/lotSelector/useOperativeReserve";
import { StoreSelectorPanel } from "../../../../components/storeSelectorPanel";
import { onCanChangeData } from "../../../../system/functions/onCanChangeData";
import { onPharmacyChanged } from "../../../../system/functions/onPharmacyChanged";
import { checkStorePharmacy } from "../../../../system/functions/checkStorePharmacy";
import { useTimeout } from "../../../../system/hooks/useTimeout";
import { useComPortScanner } from "../../../../system/hooks/useHubConnection";
import FlexRow from "../../../../components/controls/FlexRow";
import useLockingDocuments from "../../../../components/lockDocuments/useLockingDocuments";
import { useUserContext } from "../../../../system/providers/userContextProvider";
import { checkLockStatus } from "../../../CommonHelperFunctions";
import { IStoreDTO } from "../../../../libs/coreapi-dto/dirs/store";
import { DictionaryInput } from "../../../../components/controls/dictionaryInput";
import { SelectDocumentModalWindow } from "../../../../components/modalWindows/SelectDocumentModalWindow";
import { InvoiceDataProvider } from "../../../../Services/DataProviders/InvoiceDataProvider";
import { useTabsContext } from "../../../../system/providers/tabsProvider";
import { Checkbox } from '../../../../components/checkboxes/checkbox';
import { ContractorDataProvider } from "../../../../Services/DataProviders/ContractorDataProvider";
import { IContractorDTO } from "../../../../libs/coreapi-dto/dirs/contractor";
import { KizBoxEntity } from "../../../Dictionaries/Kiz/KizBoxEntity";
import { KizParsed } from "../../../Dictionaries/Kiz/KizParsed";
import { validateDuplicateKizs } from "../../../../system/functions/validateDuplicateKizs";
import buffer from "buffer";
import { GosContractSearchSelectorModal } from "../../../Dictionaries/GosContract/components/GosContractSearchSelectorModal";
import { GosContractDataProvider } from "../../../../Services/DataProviders/GosContractDataProvider";
import { IGosContractDTO } from "../../../../libs/coreapi-dto/dirs/gosContract";
import { roundMoneyFormat } from "../../../../system/functions/round";
import { DisposalReasonGismtSelectorModalSelectorModal } from "../../../Dictionaries/DisposalReasonGismt/components/DisposalReasonGismtSelectorModal";
import { useDisposalReasonGismt } from "../../../../system/hooks/useDisposalReasonGismt";
import { ConfirmationItemsModal } from "../../../../components/modalWindows/ConfirmationItemsModal";
import { RequestForMovementDataProvider } from "../../../../Services/DataProviders/RequestForMovementDataProvider";
import { useInvoiceItemTabSettings } from "../../Invoice/InvoiceCreator/InvoiceItemCreator/useInvoiceItemTabSettings";

import { GtinListInfoDto, GtinInfoDto } from "../../../../@types/kiz";
import { CheckKizResultsModalWindow } from "../../../../components/modalWindows/CheckKizResultsModalWindow";
import { usePolling } from "../../../../system/hooks/usePolling";
import { Spinner } from '../../../../components/spiner/Spinner';
import changeableGridStyles from "../../../../components/grids/changeableGrid/Styles/ChangeableGrid.module.scss";
import { InvoiceStatusCell } from "../../Invoice/InvoiceCreator/InvoiceStatusCell";
import { MovementDataProvider } from "../../../../Services/DataProviders/MovementDataProvider";
import { ILotsViewItem } from "../../../Accounting/Lots/LotsSelector";
import { ConstructorSchemesDataProvider } from "../../../../Services/DataProviders/ConstructorSchemesDataProvider";

interface IValidator {
    storeFrom: IEntitySimpleDTO;
    storeTo: IEntitySimpleDTO;
    contractorFrom: IEntitySimpleDTO;
    documentDate: DateTime;
    disposalReasonGismt: IEntitySimpleDTO;
}
interface IBaseFields {
    contractorFrom: IEntitySimpleDTO;
    contractorTo: IEntitySimpleDTO;
    storeFrom: IEntitySimpleDTO;
    storeTo: IEntitySimpleDTO;
    storeFromLot: IEntitySimpleDTO;
}
interface ICreatorItem {
    show: boolean;
    item: ILotDTO | null;
    editItem?: IMovementItemEditDTO | null;
}

interface IMessageModalProps {
    show: boolean;
    message: string;
    btSaveOrOk?: BtSaveOrOk;
}

interface IDisplayItem extends IDocumentItemCostInfoViewDTO {
    idGlobal: string;
    idLotFromGlobal: string;
    goodsName: string;
    scalingRatioDisplayName: string;
    actualQuantity: number;
    quantity: number;
    goodsCode: string,
    producer: string,
    isKiz: boolean;
    countKizScan: number | undefined;
    numerator: number;
    denominator: number;
    supplierFrom?: string
    supplierTo?: string
    supplier?: string
    dateCreated: DateTime,
    isOsu?: boolean,
    gosContractName: string    
    lotName?: string
    lotNameParent?: string
    seriesNumber?: string
    bestBefore?: DateTime
    gosContractFundingSourseName: string,
    lineStatus?: 'blue' | 'green' | 'red' | 'yellow'; 
    financialSecurityCode: string;
}
export interface ICreateItem {
    item: IMovementItemEditDTO;
    displayItem: IDisplayItem;
    filter: IItemFilter;
}

interface IKizsKizBoxes {
    idGlobal?: string;
    kizs?: IKizDTO[];
    kizBoxes?: IKizBoxDTO[];
}

interface IReturnCreatedItem {
    displayItem: any;
    createdItem: any;
}

interface ICheckKizState {
    isChecking: boolean;
    results: GtinInfoDto[] | null;
    showModal: boolean;
    isRemoving: boolean;
}

export const MovementUpdateForm: FC<IDocumentUpdateFormProps<IMovementGetDTO, IMovementItemGetDTO[], IMovementUpdateDTO>> = (props) => {
    const appContext = useAppContext();
    const operativeReserve = useOperativeReserve();
    const lockingDocuments = useLockingDocuments();
    const [idLockingDocument, setIdLockingDocument] = useState<string|undefined>();
    const userContext = useUserContext();
    const lockFromPermission = checkLockStatus(props.permission as IPermission, userContext.userPermission);
    const [onlyRead, setOnlyRead] = useState((props.variant === 'edit' && (props.document?.documentState === 'proc' || props.document?.documentState === 'sent' || lockFromPermission)) ? true : false);
    const idTable = IdTableVariant.Movement


    // DP
    const lotDP = new LotDataProvider(appContext.coreApiService);
    const storeDP = new StoreDataProvider(appContext.coreApiService);
    const scalingRatioDP = new ScalingRatioDataProvider(appContext.coreApiService);
    const kizDP = new KizDataProvider(appContext.coreApiService);
    const invoiceDP = new InvoiceDataProvider(appContext.coreApiService);
    const requestForMovementDP = new RequestForMovementDataProvider(appContext.coreApiService);
    const contractorDP = new ContractorDataProvider(appContext.coreApiService);
    const gosContractDP = new GosContractDataProvider(appContext.coreApiService);
    //const disposalReasonGismtDP = new DisposalReasonGismtDataProvider(appContext.coreApiService);
    const constructorSchemesDP = new ConstructorSchemesDataProvider(appContext.coreApiService);

    const [data, setData] = useState<IMovementCreateDTO>(
        props.documentUpdate ??
            ({
                idGlobal: props.idGlobal,
                documentDate: DateTime.now(),
                userComment: "",
                isNewBarcode: false,
                items: [] as IMovementItemCreateDTO[],
            } as IMovementCreateDTO)
    );

    const [supplierCostInfo, setSupplierCostInfo] = useState<ISummaryCostInfoDTO>();
    const [retailCostInfo, setRetailCostInfo] = useState<ISummaryCostInfoDTO>();

    const [displayItems, setDisplayItems] = useState<IDisplayItem[]>([]);
    const [totalCount] = useState<number>(0);
    const [baseFields, setBaseFields] = useState<IBaseFields>({
        contractorFrom: {} as IEntitySimpleDTO,
        contractorTo: {} as IEntitySimpleDTO,
        storeFrom: {} as IEntitySimpleDTO,
        storeTo: {} as IEntitySimpleDTO,
        storeFromLot: {} as IEntitySimpleDTO,
    });
    const [mnemocode, setMnemocode] = useState<string>(props.document?.mnemocode ?? "");

    const [contractorFrom, setContractorFrom] = useState<IContractorDTO>();
    const [contractorTo, setContractorTo] = useState<IContractorDTO>();
    
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [autoSelectEnabled, setAutoSelectEnabled] = useState<boolean>(true);
    const [kizScanModal, setKizScanModal] = useState<boolean>(false);
    const [creatorItem, setCreatorItem] = useState<ICreatorItem>({
        show: false,
        item: null,
    });
    const [scanData, setScanData] = useState<string>("");
    const [showMessageModal, setShowMessageModal] = useState<IMessageModalProps>({
        show: false,
        message: "",
    });
    //filter
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [lotGridFilter, dispatchLotGridFilter] = useGridFilter();
    const [itemsFilter, setItemsFilter] = useState<IItemFilter[]>([]);
    const [itemsValidation, setItemsValidation] = useState<IValidationItem[]>([]);

    const { t } = useTranslation();
    const baseT = (value: string) => t("documents.movement." + value);
    const errorsT = (value: string) => t("errors." + value);

    const defaultSearchOption = {displayName: t("documents.movement.goodsName"), value: SearchOption.goodsName} as IOption;
    const [searchOption, setSearchOption] = useState<IOption>(defaultSearchOption);

    const [selectedScalingRatio, setSelectedScalingRatio] = useState<IScalingRatioDTO | null>(null);
    const [lotsViewItem, setLotsViewItem] = useState<ILotsViewItem>({
        item: null,
        show: false,
        multiple: true
    });

    const [selectedItemCreateDto, setSelectedItemCreateDto] = useState<IMovementItemCreateDTO>();
    const [scanFocus, setScanFocus] = useState<boolean>(false);
    const timeout = useRef<NodeJS.Timeout>();
    const [setTimer, clearTimer]  = useTimeout()

    const [isCompactMode, setIsCompactMode] = useState<boolean>(false);
    const [isCompactStore, setIsCompactStore] = useState<boolean>(false);

    const { pollMultipleTasks } = usePolling();

    const [checkKizState, setCheckKizState] = useState<ICheckKizState>({
        isChecking: false,
        results: null,
        showModal: false,
        isRemoving: false
    });

    // baseDocument
    const [baseDocument, setBaseDocument] = useState<string>();
    const [showMessageModalValidBaseDocument, setShowMessageModalValidBaseDocument] = useState<boolean>(false);
    const [showMessageModalActualQuantityChanged, setShowMessageModalActualQuantityChanged] = useState<boolean>(false);
    const [selectBaseDocument, setSelectBaseDocument] = useState<boolean>(false);
    const [isSkipLotSelection, setIsSkipLotSelection] = useState<boolean>(true);

    const tabsContext = useTabsContext();
    const currentIdTab = useRef<string>('');    

    const [kizsKizBoxes, setKizsKizBoxes] = useState<IKizsKizBoxes[]>([])
    
    const [gosContract, setGosContract] = useState<IEntitySimpleDTO | null>(null);

    const [requiredScanKiz, setRequiredScanKiz] = useState<boolean>(true);

    const { getBooleanSetting } = useInvoiceItemTabSettings();
    const showLastSearchQuery = getBooleanSetting('showLastSearchQuery')
    const lastSearchQuerySettings = {
            showLastSearchQuery: showLastSearchQuery,
            searchOption: searchOption,
            documentKey: 'invoiceItemCreator' as DocumentKey,
            fieldName: 'inputAccompanyingSelectionGoods'
        };

    const movementDP = new MovementDataProvider(appContext.coreApiService);    

    const calculateLineStatus = (item: IMovementItemCreateDTO): 'blue' | 'green' | 'red' | 'yellow' => {
        let totalScanned = (item.kizs?.length || 0);
    
        if (item.kizBoxes && item.kizBoxes.length > 0) {
            item.kizBoxes.forEach(box => {
                totalScanned += (box.quantity || 1);
            });
        }
    
        const expected = item.quantity;
    
        if (totalScanned === 0) {
            return 'blue';
        }
    
        if (totalScanned < expected) {
            return 'yellow';
        }
    
        const kizStatuses = [
            ...(item.kizs?.map(k => k.stateMDLP) || []),
            ...(item.kizBoxes?.map(b => b.stateMDLP) || [])
        ];
    
        if (kizStatuses.length > 0) {
            const hasErrors = kizStatuses.some(s => 
                s === "ErrorDateExpired" ||
                s === "ErrorBranchId" ||
                s === "ErrorInCirculation" ||
                s === "ErrorNotFound" ||
                s === "ErrorSscc"
            );
        
            const allOk = kizStatuses.every(s => 
                s === "Ok" || s === "in_circulation" || s === "in_realization"
            );
        
            if (hasErrors) return 'red';
            if (allOk) return 'green';
        }
    
        if (totalScanned >= expected) {
            if (checkKizState.results && checkKizState.results.length > 0) {
                const itemResults = checkKizState.results.filter(r => r.gtin === item.gtin);
                if (itemResults.length > 0) {
                    const hasErrors = itemResults.some(r => r.state !== "Ok");
                    if (hasErrors) return 'red';
                    return 'green';
                }
            }
            return 'green';
        }
    
        return 'blue';
    };

    const onCheckSgtinsAction = async () => {
        if (!data.idGlobal) {
            renderGlobalAlert({
                variant: "error",
                statusCode: 400,
                title: baseT("checkKizError"),
                detail: t("documents.movement.checkKizErrors.documentNotSaved")
            });
            return;
        }

        const hasKizs = data.items.some(item => 
            (item.kizs && item.kizs.length > 0) || 
            (item.kizBoxes && item.kizBoxes.length > 0)
        );
    
        if (!hasKizs) {
            renderGlobalAlert({
                variant: "success",
                statusCode: 200,
                title: t("documents.movement.checkKizErrors.noKizs"),
                detail: t("documents.movement.checkKizErrors.noKizsDetail")
            });
            return;
        }

        setCheckKizState(prev => ({ ...prev, isChecking: true }));
    
        try {
            const documentId = data.idGlobal;
        
            const taskIds = await new Promise<string[]>((resolve, reject) => {
                movementDP.checkSgtins(documentId,
                    (response) => {
                        if (response && response.taskIds) {
                            resolve(response.taskIds);
                        } else if (Array.isArray(response)) {
                            resolve(response);
                        } else {
                            reject({ message: t("documents.movement.checkKizErrors.noTasks") });
                        }
                    },
                    (error) => {
                        console.error("checkSgtins error:", error);
                        reject(error);
                    }
                );
            });
        
            if (!taskIds || taskIds.length === 0) {
                renderGlobalAlert({
                    variant: "warning",
                    statusCode: 400,
                    title: t("documents.movement.checkKizErrors.noTasks"),
                    detail: t("documents.movement.checkKizErrors.noTasks")
                });
                setCheckKizState(prev => ({ ...prev, isChecking: false }));
                return;
            }
        
            const allResults = await pollMultipleTasks(
                taskIds,
                async (taskId: string) => {
                    return new Promise((resolve, reject) => {
                        movementDP.getCheckSgtinsResult(
                            taskId,
                            data.idGlobal!,
                            (response) => {
                                resolve(response);
                            },
                            (error) => {
                                reject(error);
                            }
                        );
                    });
                },
                {
                    maxAttempts: 60,
                    maxErrorAttempts: 10,
                    intervalMs: 5000,
                    timeoutMs: 300000,
                    errorMessages: {
                        maxAttemptsError: t("documents.movement.checkKizErrors.maxAttemptsError"),
                        pollingTimeout: t("documents.movement.checkKizErrors.pollingTimeout"),
                        taskNotFound: t("documents.movement.checkKizErrors.taskNotFound")
                    }
                }
            );
        
            const allGtinInfo = allResults.flatMap(r => r?.gtinInfoList || []);
        
            setCheckKizState(prev => ({ 
                ...prev, 
                results: allGtinInfo,
                isChecking: false,
                showModal: allGtinInfo.some(r => r.state !== "Ok")
            }));
        
            updateDisplayItemsStatus(data.items);
        
            const errorResults = allGtinInfo.filter(r => r.state !== "Ok");
        
            if (errorResults.length === 0) {
                renderGlobalAlert({
                    variant: "success",
                    statusCode: 200,
                    title: baseT("checkKizSuccess"),
                    detail: baseT("checkKizSuccess")
                });
                props.refresh?.();
            }
        
        } catch (err) {
            const error = err as any;
            let errorMessage = "";
        
            if (typeof error?.message === 'string') {
                errorMessage = error.message;
            } else if (error?.message?.title) {
                errorMessage = error.message.title;
            } else if (error?.title) {
                errorMessage = error.title;
            } else {
                errorMessage = JSON.stringify(error?.message || error);
            }
        
            renderGlobalAlert({
                variant: "error",
                statusCode: error?.statusCode || error?.message?.statusCode || 500,
                title: baseT("checkKizError"),
                detail: errorMessage || t("documents.movement.checkKizErrors.unknownError")
            });
        } finally {
            setCheckKizState(prev => ({ ...prev, isChecking: false }));
        }
    };

    const updateDisplayItemsStatus = (items: IMovementItemCreateDTO[]) => {
        setDisplayItems(prev => prev.map(displayItem => {
            const item = items.find(i => i.idGlobal === displayItem.idGlobal);
            return {
                ...displayItem,
                lineStatus: item ? calculateLineStatus(item) : 'blue'
            };
        }));
    };

    const handleRemoveInvalidKizs = async (invalidSgtins: string[]) => {
        if (!data.idGlobal) {
            renderGlobalAlert({
                variant: "error",
                statusCode: 400,
                title: baseT("checkKizError"),
                detail: t("documents.movement.checkKizErrors.documentNotSaved")
            });
            return;
        }

        if (!invalidSgtins || invalidSgtins.length === 0) {
            setCheckKizState(prev => ({ ...prev, showModal: false }));
            return;
        }

        setCheckKizState(prev => ({ ...prev, isRemoving: true }));
    
        const updatedItems = data.items.map(item => {
            const remainingKizs = item.kizs?.filter(kiz => {
                const shouldKeep = !invalidSgtins.includes(kiz.gtinSGtin);
                return shouldKeep;
            }) || [];
        
            const remainingKizBoxes = item.kizBoxes?.filter(box => {
                const shouldKeep = !invalidSgtins.includes(box.barcode);
                return shouldKeep;
            }) || [];
        
            return {
                ...item,
                kizs: remainingKizs,
                kizBoxes: remainingKizBoxes,
                kizCount: remainingKizs.length,
                kizBoxCount: remainingKizBoxes.length
            };
        });
    
        setData({ ...data, items: updatedItems });
        updateDisplayItemsStatus(updatedItems);
        setCheckKizState(prev => ({ 
            ...prev, 
            showModal: false, 
            results: null,
            isRemoving: false 
        }));

        renderGlobalAlert({
            variant: "success",
            statusCode: 200,
            title: t("documents.movement.kizRemovedSuccess"),
            detail: `${t("documents.movement.kizRemovedSuccess")}: ${invalidSgtins.length}`
        });

        if (props.save) {
            props.save({ ...data, items: updatedItems });
        }
    };

    const handleIgnoreCheck = async () => {
    if (!data.idGlobal) {
        setCheckKizState(prev => ({ ...prev, showModal: false }));
        return;
    }

        try {
            await new Promise<void>((resolve, reject) => {
                movementDP.logIgnoreCheck(
                    data.idGlobal!,
                    () => {
                    resolve();
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        } catch (err) {
            console.error("Error logging ignore check:", err);
        }

        setCheckKizState(prev => ({ ...prev, showModal: false }));
    
        if (props.document?.idGlobal) {
            props.refresh?.();
        }
    };

    const scanner = useComPortScanner((scanData: string) => {
        if (kizScanModal) return
        const decodedText = atob(scanData);

        let kizParsed = new KizParsed(decodedText)
        const encodedGtinSgtin = encodeURIComponent(kizParsed.gtinSgtin);
        const encodedBarcodeBase64 = encodeURIComponent(kizParsed.rawBarcodeCorrectedBase64);
        const encodedDecodedText = encodeURIComponent(decodedText);

        if (kizParsed.isKiz) {
            const saveRawBarcode = (lot: ILotByIdDTO, rawBarcode: string) => {
                if (lot && 
                    lot.idKizGlobalRequested && 
                    lot.idKizGlobalRequested.length > 0 && 
                    lot.idKizGlobalRequested != uuidNull) {

                    kizDP.saveRawBarcode(lot.idKizGlobalRequested, rawBarcode)
                }
            }

            const idStoreGlobal: string | null = data?.idStoreFromGlobal ?? null;
            lotDP.getListLotByGtinSgtin(encodedGtinSgtin, idTable as number, idStoreGlobal, (lots: ILotsByIdDTO[]) => {

                // Несколько результатов
                if (lots.length > 1) {
                    setLotsViewItem(
                        { 
                            item: lots, 
                            show: true, 
                            multiple: false, 
                            queryArg: encodedDecodedText, 
                            handleLot: handleLotSelect 
                        });
                    saveRawBarcode(lots[0], encodedBarcodeBase64);

                    return;
                }

                const singleLot = lots[0];
                
                saveRawBarcode(singleLot, encodedBarcodeBase64);
                setScanData(encodedDecodedText)
                handleLotSelect(singleLot, encodedDecodedText)
            })
        }
    })

    const [showMessageModalValidDocument, setShowMessageModalValidDocument] = useState<IMessageModalProps>({ show: false, message: "" });

    const [isHealthCareDocumentScheme, setIsHealthCareDocumentScheme] = useState<boolean>(false);

    const isMovementWithinSameContractor = Boolean(
        contractorFrom?.idGlobal &&
        contractorTo?.idGlobal &&
        contractorFrom.idGlobal === contractorTo.idGlobal
    );
    const isMovementBetweenDifferentLegalEntities = Boolean(
        contractorFrom?.legalEntity?.idGlobal &&
        contractorTo?.legalEntity?.idGlobal &&
        contractorFrom.legalEntity.idGlobal !== contractorTo.legalEntity.idGlobal
    );

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            storeFrom: {
                required: {
                    value: data?.idStoreFromGlobal ? false : true,
                    message: errorsT("required"),
                },
            },
            storeTo: {
                required: {
                    value: data?.idStoreToGlobal ? false : true,
                    message: errorsT("required"),
                },
            },
            contractorFrom: {
                custom: {
                    isValid: () => {
                        const itemsKizs = data.items.filter(c => c.isKiz === true && c.denominator > 1)
                        if (itemsKizs.length === 0) return true

                        // Между складами одной аптеки товар остается в рамках одного места деятельности.
                        // Исключение для схемы 531 / 10531
                        if (isMovementWithinSameContractor || isHealthCareDocumentScheme) return true;

                        // Разукомплектованный КИЗ нельзя перемещать между разными юридическими лицами.
                        // Исключение для схемы 531 / 10531
                        if (isMovementBetweenDifferentLegalEntities && !isHealthCareDocumentScheme) return false;

                        return itemsKizs.every(item => {
                            const quantityMax = itemsFilter.find(e => e.idItem === item.idGlobal)?.quantityMax;
                            const quantity = displayItems.find(e => e.idGlobal === item.idGlobal)?.quantity ?? item.quantity;

                            return quantityMax === undefined || Number(quantity) === Number(quantityMax);
                        })
                    },
                    message: isMovementBetweenDifferentLegalEntities
                        ? 'МДЛП не разрешает перемещение между разными юр. лицами разукомплектованный КИЗ'
                        : 'МДЛП разрешает перемещение между местами деятельности одного участника только полного остатка разукомплектованного КИЗ'
                },
            },
            documentDate: {
                required: {
                    value: data?.documentDate?.day ? false : true,
                    message: errorsT("required")
                }
            },
            disposalReasonGismt: {
                custom: {
                    isValid: () => {
                        if (disposalGismtForUnscannedLotsMode && disposalReasonGismt === null)
                            return false;

                        return true;
                    },
                    message: 'Не заполнена причина выбытия ГИС МТ'
                }
            }
        },
    });

    useEffect(() => {
        console.log(isHealthCareDocumentScheme)
    }, [isHealthCareDocumentScheme])

    const addDisplayItems = (items: IMovementItemGetDTO[]) => {
        setDisplayItems([
            ...items.map((x: IMovementItemGetDTO): IDisplayItem => {
                return {
                    idGlobal: x.idGlobal,
                    gosContractFundingSourseName: x.gosContractFundingSourseName,
                    idLotFromGlobal: x.lotFrom.idGlobal,
                    goodsName: x.goods.displayName,
                    scalingRatioDisplayName: x.scalingRatio.displayName,
                    actualQuantity: x.actualQuantity,
                    quantity: x.quantity,
                    goodsCode: x.goodsCode,
                    gosContractName: x.gosContractName,
                    producer: x.producer,
                    supplierVat: x.supplierCostInfo.vat,
                    supplierPrice: x.supplierCostInfo.price,
                    supplierVatPrice: x.supplierCostInfo.vatPrice,
                    supplierPriceIncVat: x.supplierCostInfo.priceIncVat,
                    supplierSum: x.supplierCostInfo.sum,
                    supplierVatSum: x.supplierCostInfo.vatSum,
                    supplierSumIncVat: x.supplierCostInfo.sumIncVat,
                    supplierAdprice: x.supplierCostInfo.adprice,

                    retailVat: x.retailCostInfo.vat,
                    retailPrice: x.retailCostInfo.price,
                    retailVatPrice: x.retailCostInfo.vatPrice,
                    retailPriceIncVat: x.retailCostInfo.priceIncVat,
                    retailSum: x.retailCostInfo.sum,
                    retailVatSum: x.retailCostInfo.vatSum,
                    retailSumIncVat: x.retailCostInfo.sumIncVat,
                    retailAdprice: x.retailCostInfo.adprice,

                    isKiz: x.isKiz,
                    countKizScan: x.isKiz === true ? x.kizCount + x.kizBoxCount: undefined,
                    denominator: x.denominator,
                    numerator: x.numerator,
                    supplierFrom: x.supplierFrom,
                    supplierTo: x.supplierTo,
                    supplier: x.supplier,
                    dateCreated: x.dateCreated,
                    isOsu: x.kizOsuDto?.barcode !== undefined,
                    lotName: x.lotName,
                    lotNameParent: x.lotNameParent,
                    seriesNumber: x.seriesNumber,
                    bestBefore: x.bestBefore,
                    financialSecurityCode: x?.financialSecurity?.displayName
                };
            }),
        ]);
    };

    useEffect(() => dispatchLotGridFilter(onPharmacyChanged(baseFields.contractorFrom.idGlobal)), [baseFields.contractorFrom]);

    useEffect(() => {
        if (tabsContext?.currentTab) {
            currentIdTab.current = tabsContext.currentTab?.id;
        }
        if (props.documentItems) {
            addDisplayItems(props.documentItems);
        }
    }, []);

    useEffect(() => {
        const handleTabClose = (event) => {
            operativeReserve.deleteAll({
                idTable: IdTableVariant.Movement,
                idDocument: data.idGlobal as string,
            });
            lockingDocuments.delete({
                idTable: IdTableVariant.Movement,
                idDocument: data.idGlobal as string,
            });
            return (event.returnValue = "");
        };

        window.addEventListener("beforeunload", handleTabClose);

        return () => {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, []);

    const addItemsFilter = () => {
        props.document?.items.forEach((x) => {
            lotDP.getById(x.lotFrom.idGlobal, (e) => {
                setItemsFilter((items) => [
                    ...items.filter((item) => item.idItem !== x.idGlobal),
                    {
                        idItem: x.idGlobal,
                        quantityMax: e.quantityRem + e.quantityRes,
                        quantityMin: 0,
                    },
                ]);
            });
        });
    };

    // Блокировка документа
    const requestUpdateLockingDocumentTimeout = useRef<NodeJS.Timeout>();
    const isUpdatingLockingDocument = useRef(false);

    useEffect(() => {
        // Если документ не определён — ничего не делаем
        if (!idLockingDocument) return;

        // Если уже идёт обновление — не ставим новый таймер
        if (isUpdatingLockingDocument.current) return;

        // Отменяем предыдущий таймер
        if (requestUpdateLockingDocumentTimeout.current) {
            clearTimeout(requestUpdateLockingDocumentTimeout.current);
        }

        clearTimeout(requestUpdateLockingDocumentTimeout.current as NodeJS.Timeout);
        requestUpdateLockingDocumentTimeout.current = setTimeout(() => {

            isUpdatingLockingDocument.current = true;

            lockingDocuments.update(idLockingDocument, (e) => {
                isUpdatingLockingDocument.current = false;
            },
                () => {
                    isUpdatingLockingDocument.current = false;
                })
        }, Number(process.env.REACT_APP_INTERVAL_REQUEST));
    }, [data.documentDate, data.idGosContractGlobal, data.idStoreToGlobal, data.idStoreFromGlobal, data.items]);

    useEffect(() => {
        if ((props.variant === "edit" || props.variant === "copy") && props.documentUpdate && props.documentItems && props.document) {
            if (props.variant === "edit")
                lockingDocuments.check(data.idGlobal as string, (e)=> {
                    if (e) setOnlyRead(true)
                    else
                        lockingDocuments.send({
                            idTable: IdTableVariant.Movement,
                            idDocument: data.idGlobal as string,
                        }, (e)=> {
                            setIdLockingDocument(e)
                        });
                })

            setData(props.documentUpdate);
            setItemsValidation(
                props.documentUpdate.items.map((x) => ({
                    err: false,
                    message: "",
                    idGlobal: x.idGlobal,
                }))
            );
            setMnemocode(props.document.mnemocode);
            addDisplayItems(props.documentItems);
            addItemsFilter();
            if (props.document.baseDocumentInfo?.idTable === IdTableVariant.Invoice) {
                invoiceDP.getById(props.document.baseDocumentInfo.idDocument, (entity) => setBaseDocument(entity.displayName))
            }
            if (props.document.baseDocumentInfo?.idTable === IdTableVariant.RequestForMovement) {
                requestForMovementDP.getById(props.document.baseDocumentInfo.idDocument, (entity) => setBaseDocument(entity.displayName))
            }
        }
    }, [props.variant]);

    useEffect(() => {
        if (selectedItem) {
            scanner.isComPortScanner && setScanFocus(true);
            let selectedItemDto = data.items.find((x) => x.idGlobal === selectedItem.idGlobal) as IMovementItemCreateDTO;
            if (selectedItemDto) {
                setSelectedItemCreateDto(selectedItemDto);
                scalingRatioDP.overrideGetById(selectedItemDto.idGoodsGlobal, selectedItemDto.idScalingRatioGlobal as string, (e) => {
                    setSelectedScalingRatio(e);
                });
            } else {
                setSelectedItemCreateDto(undefined);
                setSelectedScalingRatio(null);
            }
        } else {
            scanner.isComPortScanner && setScanFocus(false);
            setSelectedItemCreateDto(undefined);
            setSelectedScalingRatio(null);
        }
    }, [selectedItem]);

    const getStoreFrom = (callback: (store: IStoreDTO | null) => void) => {
        if (!data?.idStoreFromGlobal) {
            callback(null)
            return
        } 
        storeDP.getById(data.idStoreFromGlobal as string, (e) => {
            callback(e);
        })
    }

    const getStoreTo = (callback: (store: IStoreDTO | null) => void) => {
        if (!data?.idStoreToGlobal) {
            callback(null)
            return
        }
        storeDP.getById(data.idStoreToGlobal as string, (e) => {
            callback(e);
        })
    }

    const handleRequiredScanKizFromStores = (storeFrom: IStoreDTO | null, storeTo: IStoreDTO | null) => {
        const isRequired = storeFrom?.kizScanning === true || storeTo?.kizScanning === true;
        setRequiredScanKiz(isRequired);
    };

    useEffect(() => {
        if (data?.idStoreFromGlobal || data?.idStoreToGlobal) {
            getStoreFrom((storeFrom: IStoreDTO | null) => {
                getStoreTo((storeTo: IStoreDTO | null) => {
                    setBaseFields({
                        ...baseFields,
                        contractorFrom: storeFrom?.contractor ?? {} as IEntitySimpleDTO,
                        contractorTo: storeTo?.contractor ?? {} as IEntitySimpleDTO,
                        storeFrom: storeFrom === null ? {} as IEntitySimpleDTO : {
                            displayName: storeFrom.name,
                            idGlobal: data.idStoreFromGlobal
                        } as IEntitySimpleDTO ,
                        storeTo: storeTo === null ? {} as IEntitySimpleDTO : {
                            displayName: storeTo.name,
                            idGlobal: data.idStoreToGlobal
                        } as IEntitySimpleDTO
                    })

                    if (data.idStoreFromGlobal) {
                        dispatchLotGridFilter({
                            type: "addColumnFilter",
                            payload: {
                                name: "idStoreGlobal",
                                operator: "Eq",
                                value: data.idStoreFromGlobal,
                            },
                        });

                        // Выгрузить тип схемы
                        if (storeTo?.contractor) {
                            constructorSchemesDP.getDocType(IdTableVariant.Movement, data.idStoreFromGlobal, storeTo.contractor.idGlobal, (schemeType: string) => {
                                const isHealthCareScheme = schemeType.toLowerCase().includes("healthcare") || false;
                                setIsHealthCareDocumentScheme(isHealthCareScheme);
                            })
                        }
                    }

                    handleRequiredScanKizFromStores(storeFrom, storeTo)
                })
            })
        }  
        
        if (!data?.idStoreFromGlobal) {
            setBaseFields({
                ...baseFields,
                storeFrom: {} as IEntitySimpleDTO,
            });
            dispatchLotGridFilter({
                type: "deleteColumnFilter",
                payload: "idStoreGlobal",
            });
        }
    }, [data?.idStoreFromGlobal, data?.idStoreToGlobal]);

    const getGosContract = (callback: (store: IGosContractDTO | null) => void) => {
        if (!data?.idStoreToGlobal) {
            callback(null)
            return
        }
        gosContractDP.getById(data.idGosContractGlobal as string, (e) => {
            callback(e);
        })
    }

    useEffect(() => {
        if (data?.idGosContractGlobal) {
            getGosContract((gc) => {
                setGosContract({ idGlobal: gc?.idGlobal as string, displayName: gc?.info.name as string })

                gc?.idGlobal && dispatchLotGridFilter({
                    type: "addColumnFilter",
                    payload: {
                        name: "idGosContractGlobal",
                        operator: "Eq",
                        value: gc?.idGlobal
                    }
                })
            })
        }
    }, [data?.idGosContractGlobal]);

    const kizDisabled = (): boolean => {
        const item = data.items.find((item) => item.idGlobal == selectedItem?.idGlobal)
        if ((onlyRead ? (props.document?.isCrosspharmacy && props.document?.documentState === 'proc') : false) || !((item?.isKiz) || (item?.isOsu))) return true
        return false
    };

    const addItem = (value: IChangeDataGrid) => {

        let quantity = (value.value as number)
        let indexItem = data.items.findIndex((item) => item.idGlobal === value.idGlobal);
        let takeDataObj = data.items.find((item) => item.idGlobal === value.idGlobal) as IMovementItemCreateDTO;

        let indexDisplayItem = displayItems.findIndex((item) => item.idGlobal === value.idGlobal);
        let takeDisplayObj = displayItems.find((item) => item.idGlobal === value.idGlobal) as IDisplayItem;

        let newItem: IMovementItemCreateDTO = {
            ...takeDataObj,
            retailCostInfo: {
                ...takeDataObj.retailCostInfo,
                vat: takeDataObj.retailCostInfo.vat,
                sum: roundMoneyFormat(takeDataObj.retailCostInfo.price * quantity),
                vatSum: roundMoneyFormat(takeDataObj.retailCostInfo.vatPrice * quantity),
                sumIncVat: roundMoneyFormat(takeDataObj.retailCostInfo.priceIncVat * quantity),
            } as ICostInfoDTO,
            supplierCostInfo: {
                ...takeDataObj.supplierCostInfo,
                    vat: takeDataObj.supplierCostInfo.vat,
                    sum: roundMoneyFormat(takeDataObj.supplierCostInfo.price * quantity),
                    vatSum: roundMoneyFormat(takeDataObj.supplierCostInfo.vatPrice * quantity),
                    sumIncVat: roundMoneyFormat(takeDataObj.supplierCostInfo.priceIncVat * quantity),
            } as ICostInfoDTO,
            quantity: quantity,
        };

        let newDisplayItem: IDisplayItem = {
            ...takeDisplayObj,
            supplierVat: newItem.supplierCostInfo.vat,
            supplierPrice: newItem.supplierCostInfo.price,
            supplierVatPrice: newItem.supplierCostInfo.vatPrice,
            supplierPriceIncVat: newItem.supplierCostInfo.priceIncVat,
            supplierSum: newItem.supplierCostInfo.sum,
            supplierVatSum: newItem.supplierCostInfo.vatSum,
            supplierSumIncVat: newItem.supplierCostInfo.sumIncVat,
            supplierAdprice: newItem.supplierCostInfo.adprice,

            retailVat: newItem.retailCostInfo.vat,
            retailPrice: newItem.retailCostInfo.price,
            retailVatPrice: newItem.retailCostInfo.vatPrice,
            retailPriceIncVat: newItem.retailCostInfo.priceIncVat,
            retailSum: newItem.retailCostInfo.sum,
            retailVatSum: newItem.retailCostInfo.vatSum,
            retailSumIncVat: newItem.retailCostInfo.sumIncVat,
            retailAdprice: newItem.retailCostInfo.adprice,
            quantity: quantity,
        };

        setData({
            ...data,
            items: addValueToArray(data.items, indexItem, newItem),
        });
        setDisplayItems([...addValueToArray(displayItems, indexDisplayItem, newDisplayItem)]);
    };

    const addItemForCrosspharmacy = (value: IChangeDataGrid) => {

        let actualQuantity = (value.value as number)
        let indexItem = data.items.findIndex((item) => item.idGlobal === value.idGlobal);
        let takeDataObj = data.items.find((item) => item.idGlobal === value.idGlobal) as IMovementItemCreateDTO;

        let indexDisplayItem = displayItems.findIndex((item) => item.idGlobal === value.idGlobal);
        let takeDisplayObj = displayItems.find((item) => item.idGlobal === value.idGlobal) as IDisplayItem;

        let newItem: IMovementItemCreateDTO = {
            ...takeDataObj,
            actualQuantity: actualQuantity,
        };

        let newDisplayItem: IDisplayItem = {
            ...takeDisplayObj,
            actualQuantity: actualQuantity,
        };

        setData({
            ...data,
            items: addValueToArray(data.items, indexItem, newItem),
        });
        setDisplayItems([...addValueToArray(displayItems, indexDisplayItem, newDisplayItem)]);
    };

    useEffect(() => {
        setSupplierCostInfo({
            sum: data.items.reduce((sum, item) => sum + (item.supplierCostInfo?.sum ?? 0), 0),
            vatSum: data.items.reduce((sum, item) => sum + (item.supplierCostInfo?.vatSum ?? 0), 0),
            sumIncVat: data.items.reduce((sum, item) => sum + (item.supplierCostInfo?.sumIncVat ?? 0), 0),
        });
        setRetailCostInfo({
            sum: data.items.reduce((sum, item) => sum + (item.retailCostInfo?.sum ?? 0), 0),
            vatSum: data.items.reduce((sum, item) => sum + (item.retailCostInfo?.vatSum ?? 0), 0),
            sumIncVat: data.items.reduce((sum, item) => sum + (item.retailCostInfo?.sumIncVat ?? 0), 0),
        });
    }, [data.items]);

    const isValidDocument = (items:IMovementItemCreateDTO[], showMessage: () => void): boolean => {
        var flag = true;
        if (!items || items.length === 0)
        {
            flag = false;
            showMessage();
        }
        return flag;
    }

    const [сonfirmationItemsModalJsx, setConfirmationItemsModalJsx] = useState<JSX.Element>(<></>);
    const renderConfirmationModal = (header: string, warning: string, items: string, question: string, ok: () => void, cancel: () => void) => {
        setConfirmationItemsModalJsx(
            <ConfirmationItemsModal
                header={`${header}`}
                warning={`${warning}`}
                listPositions={`${items}`}
                question={`${question}`}
                ok={ok}
                cancel={cancel}
            />
        );
    }

    const confirmSave = (save: (model: IMovementCreateDTO) => void) => {
        const hasGismtItemsWithoutReason = !disposalReasonGismt && data.items.some(item =>
            item.kizOsuDtos && item.kizOsuDtos.length > 0
        );

        if (hasGismtItemsWithoutReason) {

            const gismtItems = data.items.filter(item => item.kizOsuDtos && item.kizOsuDtos.length > 0).map(item => {
                const displayItem = displayItems.find(x => x.idGlobal === item.idGlobal);
                return displayItem?.goodsName || `Код товара '${item.goodsCode}'`;
            }).join(', ');

            renderConfirmationModal(
                "Подтверждение сохранения",
                "В документе присутствуют товары ГИС МТ без указанной причины выбытия:",
                gismtItems,
                "Вы уверены, что хотите продолжить без указания причины выбытия?",
                () => {
                    save(data)
                    setConfirmationItemsModalJsx(<></>)
                },
                () => setConfirmationItemsModalJsx(<></>)
            );
        } else {
            save(data);
        }
    }

    const onOkAction = () => {
        lockingDocuments.delete({
            idTable: IdTableVariant.Movement,
            idDocument: data.idGlobal as string,
        });

        confirmSave(props.ok);
    };

    const onOk = () => {        
        if (
            isValid() &&
            isValidDocument(data.items, () => setShowMessageModalValidDocument({ message: errorsT("validDocument"), show: true })) === true &&
            controlKiz(data.items,
                () => setShowMessageModal({ message: errorsT("kizCountNotMatch"), show: true, btSaveOrOk: "ok" }),
                DocumentType.movement,
                {
                    requiredMode: requiredScanKiz,
                    validationType: ""
                }) === true
        ) {
            onOkAction();
            scanner.disconnect();
        }
    };

    const onSave = () => {
        if (
            isValid() &&
            isValidDocument(data.items, () => setShowMessageModalValidDocument({ message: errorsT("validDocument"), show: true })) === true &&
            controlKiz(data.items,
                () => setShowMessageModal({ message: errorsT("kizCountNotMatch"), show: true, btSaveOrOk: "save" }),
                DocumentType.movement,
                {
                    requiredMode: requiredScanKiz,
                    validationType: ""
                }) === true
        ) {
            confirmSave(props.save);
        }
    };

    const onCancel = () => {
        operativeReserve.deleteAll(
            {
                idTable: IdTableVariant.Movement,
                idDocument: data.idGlobal as string,
            },
            () => {
                props.cancel();
                scanner.disconnect();
            }
        );
        lockingDocuments.delete({
            idTable: IdTableVariant.Movement,
            idDocument: data.idGlobal as string,
        });
    };
    
    const calcRow = (value: IChangeDataGrid) => {
        if (value.propertyName === "actualQuantity") {
            if (value.value !== data.items.find((item) => item.idGlobal === value.idGlobal)?.quantity)
                setShowMessageModalActualQuantityChanged(true)
            
            addItemForCrosspharmacy(value)
            
            return;
        }

        if (value.propertyName === "quantity") {
            let idLot: string = data.items.find((x) => x.idGlobal === value.idGlobal)?.idLotFromGlobal as string;
            operativeReserve.send(
                {
                    idLot: idLot,
                    idDocument: data.idGlobal as string,
                    idTable: IdTableVariant.Movement,
                    idDocumentItem: value.idGlobal,
                    quantity: value.value as number,
                },
                () => addItem(value)
            );
        } else {
            addItem(value);
        }
    }

    function setActualQuantity() {
        setData({ ...data, 
            items: data.items.map(x => {
                if (kizsKizBoxes.length > 0)
                    return {
                        ...x, 
                        kizs: kizsKizBoxes.find(z => z.idGlobal === x.idGlobal)?.kizs,
                        kizBoxes: kizsKizBoxes.find(z => z.idGlobal === x.idGlobal)?.kizBoxes,
                        actualQuantity: x.quantity
                    }

                return {
                    ...x,
                    actualQuantity: x.quantity
                }
            })
        })
        setDisplayItems([
            ...displayItems.map((x) => {
                return {
                    ...x,
                    countKizScan: x.quantity,
                    actualQuantity: x.quantity
                }
            }),
        ]);
    }

    function loadContractorFrom(idGlobal: string) {
        contractorDP.getById(idGlobal, (e) => {
            setContractorFrom(e);
        })
    }

    function loadContractorTo(idGlobal: string) {
        contractorDP.getById(idGlobal, (e) => {
            setContractorTo(e);
        })
    }

    const validateKiz =(searchQuery: string ):boolean => {
        if (KizBoxEntity.isKizBox(searchQuery) || new KizParsed(searchQuery).isKiz) {
            {
                const kizs = data.items.flatMap(x => x.kizs) as IKizDTO[]
                const kizBoxes = data.items.flatMap(x => x.kizBoxes) as IKizBoxDTO[]
                const barcode = buffer.Buffer.from(searchQuery, "ascii").toString("base64")
                if (!validateDuplicateKizs(data.items,barcode,DocumentType.movement,kizs,kizBoxes))
                {
                    renderGlobalAlert({
                        variant: "exception",
                        title: `${barcode} уже был добавлен ранее в текущем документе`,
                        statusCode: 500,
                        isSound: true
                    });
                    return false;
                }
                return true;
            }
        }  
        return true;
    }

    const {
        disposalReasonGismt,
        disposalReasonGismtEnabled,
        disposalGismtForUnscannedLotsMode,
        disposalGismtForUnscannedLotsModeEnabled,
        updateDisposalReasonGismt,
        onclearDisposalReasonGismt,
        updateDisposalGismtForUnscannedLotsMode
    } = useDisposalReasonGismt<IMovementCreateDTO>({
        data,
        setData,
        getKizs: (d) => d.items?.flatMap(x => x.kizOsuDtos) as IKizDTO[] ?? [], // flatMap специально для правильной глубины фильтра с учетом каждой строки документа
        getIdDisposalReasonGismtGlobal: (d) => d.idDisposalReasonGismtGlobal,
        getIsWithdrawalGismtForUnscannedLots: (d) => d.isWithdrawalGismtForUnscannedLots
    });

    function transformArray(lots: ILotDTO[]) {
        const edit: IMovementItemCreateDTO[] = [];
        const view: IDisplayItem[] = [];
        
        lots.forEach(x => {
            const idGlobal: string = uuidv4();
            const actualQuantity = data.items.find((item) => item.idLotGlobal === x.idGlobal)?.actualQuantity
            const quantity = 1

            const editEntity = {
                idGlobal: idGlobal,
                idGoodsGlobal: x.goods.idGlobal,
                idScalingRatioGlobal: x.scalingRatio.idGlobal,
                idLotFromGlobal: x.idGlobal,
                idLotGlobal: x.idGlobal,
                producerPrice: x.producerPrice,
                actualQuantity: actualQuantity ?? 0,
                idSupplierGlobal: x.idSupplierGlobal,
                contractorPricePerUnit: 0,
                price: 0,
                priceVat: x.retailCostInfo?.vat ?? 0,
                vatSup: 0,
                isKiz: x.isKiz,
                retailCostInfo: x.retailCostInfo,
                supplierCostInfo: x.supplierCostInfo,
                kizs: [],
                kizBoxes: [],
                quantity: quantity,
                numerator: x.numerator,
                denominator: x.denominator,
                goodsCode: x.goodsCode,
                producer: x.producer.displayName,
                isPieceAccountingKizOsu: false,
                gosContractName: x.gosContractName,
                dateCreated: DateTime.now()
            };

            const viewEntity = {
                idGlobal: idGlobal,
                idGoodsGlobal: x.goods.idGlobal,
                idScalingRatioGlobal: x.scalingRatio.idGlobal,
                idLotFromGlobal: x.idGlobal,
                gosContractFundingSourseName: x.gosContractFundingSourseName,
                idLotGlobal: x.idGlobal,
                producerPrice: x.producerPrice,
                actualQuantity: actualQuantity ?? 0,
                contractorPricePerUnit: 0,
                countKizScan: undefined,
                idDocumentGlobal: props.idGlobal,
                supplierVat: x.supplierCostInfo.vat ?? 0,
                supplierPrice: x.supplierCostInfo.price ?? 0,
                supplierVatPrice: x.supplierCostInfo.vatPrice ?? 0,
                supplierPriceIncVat: x.supplierCostInfo.priceIncVat ?? 0,
                goodsCode: x.goodsCode,
                producer: x.producer.displayName,
                scalingRatioDisplayName: x.scalingRatio.displayName,
                supplierSum: x.supplierCostInfo.sum ?? 0,
                supplierVatSum: x.supplierCostInfo.vatSum ?? 0,
                supplierSumIncVat: x.supplierCostInfo.sumIncVat ?? 0,
                supplierAdprice: x.supplierCostInfo.adprice,
                retailVat: x.retailCostInfo.vat ?? 0,
                retailPrice: x.retailCostInfo.price ?? 0,
                retailVatPrice: x.retailCostInfo.vatSum ?? 0,
                retailPriceIncVat: x.retailCostInfo.priceIncVat ?? 0,
                retailSum: x.retailCostInfo.sum ?? 0,
                retailVatSum: x.retailCostInfo.vatSum ?? 0,
                retailSumIncVat: x.retailCostInfo.sumIncVat ?? 0,
                retailAdprice: x.retailCostInfo.adprice,
                goodsName: x.goods.displayName,
                scalingRatioName: x.scalingRatio.displayName,
                quantity: quantity,
                isKiz: x.isKiz ?? false,
                isKizBox: x.isKizBox,
                supplier: x.supplier,
                kizCount: x.isKiz === false ? undefined : 0,
                numerator: x.numerator,
                denominator: x.denominator,
                isPieceAccountingKizOsu: false,
                gosContractName: x.gosContractName,
                bestBefore: x.bestBefore,
                seriesNumber: x.seriesNumber,
                lotNameParent: x.lotName,
                dateCreated: DateTime.now(),
                financialSecurityCode: x?.financialSecurity?.displayName ?? null
            } as IDisplayItem
            edit.push(editEntity);
            view.push(viewEntity);
        });
        return { edit, view };
    }

    const onSelectLots = (lots: ILotDTO[]) => {
        const existingIds = new Set(data?.items?.map(item => item.idLotGlobal) ?? []);
        const uniqueRows = lots.filter(lot => !existingIds.has(lot.idGlobal))
        
        if (uniqueRows.length === 0) {
            return;
        }

        const { edit, view } = transformArray([...uniqueRows]);
        const addItems = async (items: IMovementItemCreateDTO[]) => {
            try {
                const promises = items.map((item) =>
                    new Promise<IMovementItemCreateDTO>((resolve) => {
                        operativeReserve.send(
                            {
                                idLot: item.idLotGlobal as string,
                                idTable: IdTableVariant.Movement,
                                idDocument: props.idGlobal ?? '',
                                idDocumentItem: item.idGlobal,
                                quantity: item.quantity,
                            },
                            () => resolve(item)
                        );
                    })
                );
                await Promise.all(promises);
                
                setData(prev => ({ 
                    ...prev, 
                    items: [...(prev?.items ?? []), ...items] 
                }));
                
                setDisplayItems(prev => [...(prev ?? []), ...view]);
            } catch (error) {
                console.error("Ошибка", error);
            }
        }
        addItems(edit);
    }

    useEffect(() => {
        // В режиме выбытия ГИС МТ без подтверждения
        // фильтр только для целых партий
        if (disposalGismtForUnscannedLotsMode) {
            dispatchLotGridFilter({
                type: "addColumnFilter",
                payload: {
                    name: "numerator",
                    operator: "Eq",
                    value: 1
                }
            })
            dispatchLotGridFilter({
                type: "addColumnFilter",
                payload: {
                    name: "denominator",
                    operator: "Eq",
                    value: 1
                }
            })
        } else {
            dispatchLotGridFilter({
                type: "deleteColumnFilter",
                payload: "numerator"
            })
            dispatchLotGridFilter({
                type: "deleteColumnFilter",
                payload: "denominator"
            })
        }
    }, [disposalGismtForUnscannedLotsMode])

    useEffect(() => {
        if (contractorFrom && contractorTo && data.baseDocumentInfo?.idTable === IdTableVariant.RequestForMovement)
        {
            if (contractorFrom?.legalEntity.idGlobal === contractorTo?.legalEntity.idGlobal)
                setData({ ...data, isCrosspharmacy: false })
        }
    }, [contractorFrom, contractorTo])

    
    const handleLotSelect = (lotData: any, searchQuery?: string) => {

        if (!lotData) return
        
        // Обработка списка
        if (Array.isArray(lotData as IEntitySimpleDTO[])) {
            Promise.all(
                lotData.map((singleLot: any) => 
                    new Promise(resolve => lotDP.getById(singleLot.idGlobal, resolve))
                )
            ).then(onSelectLots);
            
            return;
        }

        // Если выбран 1 лот
        lotDP.getById(lotData.idGlobal, (lot: ILotDTO) => {
            if (disposalGismtForUnscannedLotsMode && lot.numerator !== lot.denominator) {
                renderGlobalAlert({
                    variant: "error",
                    statusCode: 500,
                    title: "В режиме выбытия ГИС МТ для неподтвержденных КИЗ допускаются только целые партии",
                    detail: `Партия: ${lot.displayName}, ${lot.numerator}, ${lot.denominator}`,
                    instance: "Ошибка",
                });
                return;
            }

            if (!checkStorePharmacy(lot, baseFields.storeFrom, baseFields.contractorFrom)) return;

            if (!validateKiz(searchQuery ?? '')) return;
            if (searchOption.value === SearchOption.goodsName || 
                searchOption.value === SearchOption.goodsCodeBylot ||
                searchOption.value === SearchOption.gtinSgtin) 
            {
                lotDP.remain(lotData.idGlobal, data.idGlobal as string, (remain) => {
                    setCreatorItem({
                        show: true,
                        item: { ...lot, quantityRem: remain },
                    });
                });
            } else if (
                searchOption.value === SearchOption.kizOrKizBox ||
                searchOption.value === SearchOption.internalBarcode
            ) {
                setCreatorItem({ item: lot, show: true });
            }
        });
    };

    return (
        <>
            <BaseDocumentCreator
                valid={true}
                ok={{
                    onClick: onOk,
                    disabled: onlyRead ? (props.document?.isCrosspharmacy && props.document?.documentState === 'proc') : false || !!itemsValidation.find((x) => x.err == true) || props.isSubmitting,
                    sendRequestGlobal: props.isSubmitting
                }}
                save={{
                    onClick: onSave,
                    disabled: onlyRead ? (props.document?.isCrosspharmacy && props.document?.documentState === 'proc') : false || !!itemsValidation.find((x) => x.err == true) || props.isSubmitting,
                    sendRequestGlobal: props.isSubmitting
                }}
                print={{
                    onClick: () => {
                        return IdTableVariant.Movement;
                    },
                    onSubItemClick: () => {
                        let arr = new Array<IKeyValuePair>();
                        if (props.document != undefined && props.document.mnemocode != undefined && props.idGlobal != undefined) arr.push({ key: props.idGlobal, value: props.document.mnemocode });
                        return arr;
                    },
                }}
                cancel={{ onClick: onCancel }}
                checkKiz={{
                    title: baseT("checkKiz"),
                    onClick: onCheckSgtinsAction,
                    disabled: !data.items || data.items.length === 0 || onlyRead || props.isSubmitting,
                    sendRequestSpinner: checkKizState.isChecking
                }}
            >
                <div className={createMovementsStyles.glwrapper}>
                    <div className={createMovementsStyles.wrapper}>
                        <div>
                            {
                                <>
                                    {!isCompactMode ? (
                                        <>
                                            <GridWrapper cols={4} baseline>
                                                <TextInput 
                                                    label="Номер" 
                                                    className={createMovementsStyles.field_Number} 
                                                    inline 
                                                    disabled 
                                                    value={mnemocode} 
                                                />
                                                <DateInput
                                                    required
                                                    labelVariant="required"
                                                    value={data.documentDate}
                                                    onBlur={(value) => setData({ ...data, documentDate: value as DateTime })}
                                                    label="Дата"
                                                    error={errors.documentDate}
                                                    className={createMovementsStyles.field_Date}
                                                    inline
                                                    disabled={onlyRead}
                                                />    
                                                <div className={createMovementsStyles.chechBoxIsCrossPharmacy}>                              
                                                    <Checkbox
                                                        onChange={(checked) => setData({ ...data, isCrosspharmacy: checked })}
                                                        name="IsCrossPharmacy"
                                                        label={baseT('movementBetweenDepartments')} 
                                                        checked={data.isCrosspharmacy ?? props.document?.isCrosspharmacy ?? false}
                                                        disabled={onlyRead}
                                                    />
                                                </div>
                                                <div className={createMovementsStyles.buttonFillActual}>
                                                    <Tooltip title="Заполнить фактическое значение документальным">
                                                        <ActRevaluationButton 
                                                            onClick={() => {
                                                                setActualQuantity()
                                                            }} 
                                                            sizeVariant="normal" 
                                                            colorVariant="default"
                                                            disabled={!(onlyRead && props.document?.isCrosspharmacy) ? true : props.document?.isCrosspharmacy && props.document?.documentState === 'proc'}
                                                        />
                                                    </Tooltip>
                                                </div>
                                                <div className={createMovementsStyles.compactFieldCompactMode}>
                                                    <Tooltip title="Компактный режим">
                                                        <StockBalanceButtonCompress 
                                                            onClick={() => {
                                                                setIsCompactMode(true);
                                                                setIsCompactStore(true);
                                                            }} 
                                                            sizeVariant="normal" 
                                                            colorVariant="default" 
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </GridWrapper>
                                            <Accordion opened={true} caption={`От\u00a0кого`} id={`MovementFrom-${uuidv4()}`}> 
                                                <GridWrapper cols={2} baseline>
                                                    <StoreSelectorPanel
                                                        we
                                                        required
                                                        idTable={idTable}
                                                        change={onCanChangeData(data.items?.length)}
                                                        storeFromLot={baseFields.storeFromLot}
                                                        contractor={{
                                                            label: "Аптека",
                                                            onSelect: (value) => {
                                                                if (value)
                                                                {
                                                                    setBaseFields({ ...baseFields, contractorFrom: value });
                                                                    loadContractorFrom(value.idGlobal);
                                                                }
                                                            },
                                                            error: errors.contractorFrom,
                                                            onFocus: () => setErrors({ ...errors, contractorFrom: undefined }),
                                                            onClear: () =>
                                                                setBaseFields({
                                                                    ...baseFields,
                                                                    contractorFrom: {} as IEntitySimpleDTO,
                                                                    storeFrom: {} as IEntitySimpleDTO,
                                                                }),
                                                            disabled: onlyRead,
                                                            treeViewCheckDirectoryType:'pharmacy'
                                                        }}
                                                        store={{
                                                            label: "Склад",
                                                            value: baseFields.storeFrom,
                                                            onSelect: (value) => value && setData({ ...data, idStoreFromGlobal: value.idGlobal }),
                                                            onClear: () => setData({ ...data, idStoreFromGlobal: undefined }),
                                                            error: errors.storeFrom,
                                                            onFocus: () => setErrors({ ...errors, storeFrom: undefined }),
                                                            disabled: onlyRead
                                                        }}
                                                        notAutoComplete={isCompactStore === true || props.variant === "edit" || props.variant === "copy"}
                                                        documentStore={{ idGlobal: data.idStoreFromGlobal} as IEntitySimpleDTO}
                                                    />
                                                </GridWrapper>
                                            </Accordion>
                                            <Accordion opened={true} caption={`Кому`} id={`MovementTo-${uuidv4()}`}>
                                                <GridWrapper cols={3} baseline>
                                                    <StoreSelectorPanel
                                                        documentType={DocumentType.movement}
                                                        contractor={{
                                                            label: "Аптека",
                                                            onSelect: (value) => {
                                                                if (value) {
                                                                    setBaseFields({ ...baseFields, contractorTo: value });
                                                                    loadContractorTo(value.idGlobal);
                                                                }
                                                            },
                                                            value: baseFields.contractorTo,
                                                            error: errors.contractorFrom,
                                                            onFocus: () => setErrors({ ...errors, contractorFrom: undefined }),
                                                            onClear: () =>
                                                                setBaseFields({
                                                                    ...baseFields,
                                                                    contractorTo: {} as IEntitySimpleDTO,
                                                                    storeTo: {} as IEntitySimpleDTO,
                                                                }),
                                                            disabled: onlyRead,
                                                            treeViewCheckDirectoryType:'pharmacy',
                                                            permission: !data?.isCrosspharmacy ?  props.permission ?? 'Movement' : undefined,
                                                        }}
                                                        idTable={idTable}
                                                        isEnabledTo={true}
                                                        store={{
                                                            label: "Склад",
                                                            
                                                            value: baseFields.storeTo,
                                                            onSelect: (value) => value && setData({ ...data, idStoreToGlobal: value.idGlobal }),
                                                            error: errors.storeTo,
                                                            onFocus: () => setErrors({ ...errors, storeTo: undefined }),
                                                            onClear: () => setData({ ...data, idStoreToGlobal: "" }),
                                                            disabled: onlyRead,
                                                            permission: !data?.isCrosspharmacy ?  props.permission ?? 'Movement' : undefined,
                                                        }}
                                                        required
                                                        notAutoComplete={props.variant === "edit" || props.variant === "copy"}
                                                        documentStore={{ idGlobal: data.idStoreToGlobal} as IEntitySimpleDTO}
                                                        offUserFilter={true}
                                                        excludeUserFilter={data.isCrosspharmacy}
                                                        excludeContractors={data.isCrosspharmacy ? [
                                                            { name: "IdGlobal", value: contractorFrom?.idGlobal },
                                                            { name: "LegalEntity", value: contractorFrom?.legalEntity?.displayName }
                                                        ] as IExcludeContactorValue[] : []}
                                                    />
                                                    <GridSelectorInput
                                                        selectorModalJsx={GosContractSearchSelectorModal}
                                                        selectedEntity={gosContract}                                                        
                                                        onSelect={(value: IEntitySimpleDTO) => {
                                                            setGosContract(value);
                                                            setData({ ...data, idGosContractGlobal: value.idGlobal });
                                                            dispatchLotGridFilter({
                                                                type: "addColumnFilter",
                                                                payload: {
                                                                    name: "idGosContractGlobal",
                                                                    operator: "Eq",
                                                                    value: value.idGlobal
                                                                }
                                                            })
                                                        }}
                                                        label={t("documents.invoice.stateContract")}
                                                        onClear={() => {
                                                            setGosContract(null);
                                                            setData({ ...data, idGosContractGlobal: undefined });
                                                            dispatchLotGridFilter({
                                                                type: "deleteColumnFilter",
                                                                payload: "idGosContractGlobal"
                                                            })
                                                        }}
                                                        inline={true}
                                                        disabled={onlyRead}
                                                    />
                                                </GridWrapper>
                                                <GridWrapper cols={2}>
                                                    <GridSelectorInput
                                                        //className={createMovementsStyles.field_ReasonForMoving}
                                                        selectorModalJsx={DisposalReasonGismtSelectorModalSelectorModal}
                                                        id={"CreateMovementPharmacy"}
                                                        inline={true}
                                                        label={t("documents.movement.disposalReasonGismt")}
                                                        selectedEntity={disposalReasonGismt}
                                                        onSelect={(value: IEntitySimpleDTO) => {
                                                            updateDisposalReasonGismt(value)
                                                        }}
                                                        onClear={onclearDisposalReasonGismt}
                                                        error={errors.disposalReasonGismt}
                                                        disabled={!disposalReasonGismtEnabled || onlyRead}
                                                        clues={[t("documents.movement.clueTextDisposalReasonGismt")]}
                                                    />
                                                    <DictionaryInput 
                                                        inline
                                                        //className={createMovementsStyles.field_DocumentBase}
                                                        placeholder="-- Не выбрано --" 
                                                        value={baseDocument} 
                                                        label={t("documents.movement.baseDocument")} 
                                                        onClearClick={() => {
                                                            setBaseDocument(undefined);
                                                            setData((currentData) => ({ ...currentData, baseDocumentInfo: undefined }));
                                                        }}
                                                        onMoreClick={() => {
                                                            // !data.idStoreFromGlobal ? setShowMessageModalValidBaseDocument(true) : 
                                                            setSelectBaseDocument(true);
                                                        }}
                                                        disabled={onlyRead}
                                                    />
                                                </GridWrapper>
                                                <GridWrapper cols={3}>
                                                    <CheckBox
                                                        defaultChecked={disposalGismtForUnscannedLotsMode}
                                                        onChanged={(value) => updateDisposalGismtForUnscannedLotsMode(value)}
                                                        label={t("documents.movement.disposalGismtForUnscannedLots")}
                                                        disabled={!disposalGismtForUnscannedLotsModeEnabled || onlyRead}
                                                        clues={[t("documents.movement.clueTextDisposalGismtForUnscannedLots")]}
                                                    />
                                                    {/* <CheckBox
                                                        defaultChecked={isSkipLotSelection}
                                                        onChanged={(value) => setIsSkipLotSelection(value)}
                                                        label={t("documents.movement.isSkipLotSelection")}
                                                        disabled={onlyRead}
                                                        clues={[t("documents.movement.clueSkipLotSelection")]}
                                                    /> */}
                                                    <CheckBox
                                                        defaultChecked={isSkipLotSelection}
                                                        onChanged={(value) => setIsSkipLotSelection(value)}
                                                        label={t("documents.movement.isSkipLotSelection")}
                                                        disabled={onlyRead}
                                                        clues={[t("documents.movement.clueSkipLotSelection")]}
                                                    />
                                                    <CheckBox
                                                        onChanged={(value) => setData({ ...data, isNewBarcode: value })}
                                                        className="createMovementsStyles.field_GenerateNewBarcode"
                                                        label={`Формировать\u00a0новый\u00a0штрих\u00a0код`}
                                                        disabled={onlyRead}
                                                    />
                                                </GridWrapper>
                                            </Accordion>
                                            <Accordion opened={false} id={`MovementComment-${props.idGlobal}`} caption="Комментарий">
                                                <TextAreaInput
                                                    disabled={onlyRead}
                                                    placeholder="Напишите комментарий"
                                                    value={data.userComment ?? ""}
                                                    onChange={(value) => setData((currentData) => ({ ...currentData, userComment: value }))}
                                                />
                                            </Accordion>
                                        </>
                                    ) : (
                                        <>
                                            <GridWrapper cols={35}>
                                                <FlexRow className={createMovementsStyles.compactFieldFields} wrap>
                                                    <TextInput 
                                                        disabled 
                                                        label="Номер" 
                                                        value={mnemocode} 
                                                    />
                                                    <DateInput
                                                        required
                                                        disabled={onlyRead}
                                                        labelVariant="required"
                                                        value={data.documentDate}
                                                        onBlur={(value) => setData({ ...data, documentDate: value as DateTime })}
                                                        label="Дата"
                                                        error={errors.documentDate}
                                                    />
                                                </FlexRow>
                                                <div className={createMovementsStyles.fieldCompactMode}>
                                                    <Tooltip title="Обычный режим">
                                                        <StockBalanceButtonExpand 
                                                            onClick={() => setIsCompactMode(!isCompactMode)} 
                                                            sizeVariant="normal" 
                                                            colorVariant="default" 
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </GridWrapper>
                                                <Accordion opened={false} caption={``} id={`other-${uuidv4()}`} bold>
                                                    <Accordion opened={false} caption={`От\u00a0кого`} id={`MovementFrom-${uuidv4()}`}>
                                                        <GridWrapper cols={2}>
                                                            <StoreSelectorPanel
                                                                we
                                                                idTable={idTable}
                                                                compactMode
                                                                change={onCanChangeData(data.items.length)}
                                                                storeFromLot={baseFields.storeFromLot}
                                                                contractor={{
                                                                    label: "Аптека",
                                                                    onSelect: (value) => {
                                                                        if (value) {
                                                                            setBaseFields({ ...baseFields, contractorFrom: value });
                                                                            loadContractorFrom(value.idGlobal);
                                                                        }
                                                                    },
                                                                    onClear: () =>
                                                                        setBaseFields({
                                                                            ...baseFields,
                                                                            contractorFrom: {} as IEntitySimpleDTO,
                                                                            storeFrom: {} as IEntitySimpleDTO,
                                                                        }),
                                                                    disabled: onlyRead ? true : false,
                                                                    treeViewCheckDirectoryType: 'pharmacy'
                                                                }}
                                                                store={{
                                                                    label: "Склад",
                                                                    value: baseFields.storeFrom,
                                                                    onSelect: (value) => {
                                                                        if (value) {
                                                                            setData({ ...data, idStoreFromGlobal: value.idGlobal })
                                                                        }
                                                                    },
                                                                    onClear: () => {
                                                                        setData({ ...data, idStoreFromGlobal: undefined })
                                                                    },
                                                                    error: errors.storeFrom,
                                                                    onFocus: () => {
                                                                        setErrors({ ...errors, storeFrom: undefined })
                                                                    },
                                                                    disabled: onlyRead
                                                                }}
                                                                notAutoComplete={isCompactStore === true || props.variant === "edit" || props.variant === "copy"}
                                                                documentStore={{ idGlobal: data.idStoreFromGlobal } as IEntitySimpleDTO}
                                                            />
                                                        </GridWrapper>
                                                    </Accordion>
                                                    <Accordion opened={false} caption={`Кому`} id={`MovementTo-${uuidv4()}`}>
                                                        <FlexRow wrap>
                                                            <StoreSelectorPanel
                                                                compactMode
                                                                idTable={idTable}
                                                                isEnabledTo
                                                                contractor={{
                                                                    label: "Аптека",
                                                                    onSelect: (value) => {
                                                                        if (value) {
                                                                            setBaseFields({ ...baseFields, contractorTo: value });
                                                                            loadContractorTo(value.idGlobal);
                                                                        }
                                                                    },
                                                                    onClear: () =>
                                                                        setBaseFields({
                                                                            ...baseFields,
                                                                            contractorTo: {} as IEntitySimpleDTO,
                                                                        }),
                                                                    disabled: onlyRead ? true : false,
                                                                    treeViewCheckDirectoryType: 'pharmacy',
                                                                    permission: !data?.isCrosspharmacy ? props.permission ?? 'Movement' : undefined
                                                                }}
                                                                store={{
                                                                    label: "Склад",
                                                                    documentType: DocumentType.movement,
                                                                    value: baseFields.storeTo,
                                                                    onSelect: (value) => {
                                                                        if (value) {
                                                                            setData({ ...data, idStoreToGlobal: value.idGlobal })
                                                                        }
                                                                    },
                                                                    error: errors.storeTo,
                                                                    onClear: () => {
                                                                        setData({ ...data, idStoreToGlobal: "" })
                                                                    },
                                                                    onFocus: () => {
                                                                        setErrors({ ...errors, storeTo: undefined })
                                                                    },
                                                                    disabled: onlyRead
                                                                }}
                                                                notAutoComplete={props.variant === "edit" || props.variant === "copy"}
                                                                documentStore={{ idGlobal: data.idStoreToGlobal } as IEntitySimpleDTO}
                                                                offUserFilter={true}
                                                                excludeUserFilter={data.isCrosspharmacy}
                                                                excludeContractors={data.isCrosspharmacy ? [
                                                                    { name: "IdGlobal", value: contractorFrom?.idGlobal },
                                                                    { name: "LegalEntity", value: contractorFrom?.legalEntity.displayName }
                                                                ] as IExcludeContactorValue[] : []}
                                                            />
                                                            <GridSelectorInput
                                                                selectorModalJsx={GosContractSearchSelectorModal}
                                                                selectedEntity={gosContract}
                                                                onSelect={(value: IEntitySimpleDTO) => {
                                                                    setGosContract(value);
                                                                    setData({ ...data, idGosContractGlobal: value.idGlobal });
                                                                    dispatchLotGridFilter({
                                                                        type: "addColumnFilter",
                                                                        payload: {
                                                                            name: "idGosContractGlobal",
                                                                            operator: "Eq",
                                                                            value: value.idGlobal
                                                                        }
                                                                    })
                                                                }}
                                                                label={t("documents.invoice.stateContract")}
                                                                onClear={() => {
                                                                    setGosContract(null);
                                                                    setData({ ...data, idGosContractGlobal: undefined });
                                                                    dispatchLotGridFilter({
                                                                        type: "deleteColumnFilter",
                                                                        payload: "idGosContractGlobal"
                                                                    })
                                                                }}
                                                                disabled={onlyRead}
                                                            />
                                                            <GridSelectorInput
                                                                selectorModalJsx={DisposalReasonGismtSelectorModalSelectorModal}
                                                                id={"CreateMovementPharmacy"}
                                                                label={t("documents.movement.disposalReasonGismt")}
                                                                selectedEntity={disposalReasonGismt}
                                                                onSelect={(value: IEntitySimpleDTO) => {
                                                                    updateDisposalReasonGismt(value)
                                                                }}
                                                                onClear={onclearDisposalReasonGismt}
                                                                error={errors.disposalReasonGismt}
                                                                disabled={!disposalReasonGismtEnabled || onlyRead}
                                                                clues={[t("documents.movement.clueTextDisposalReasonGismt")]}
                                                            />
                                                            <DictionaryInput
                                                                className={createMovementsStyles.field_DocumentBase}
                                                                placeholder="-- Не выбрано --"
                                                                value={baseDocument}
                                                                label={t("documents.movement.baseDocument")}
                                                                onClearClick={() => {
                                                                    setBaseDocument(undefined);
                                                                    setData((currentData) => ({ ...currentData, baseDocumentInfo: undefined }));
                                                                }}
                                                                onMoreClick={() => {
                                                                    // !data.idStoreFromGlobal ? setShowMessageModalValidBaseDocument(true) : 
                                                                    setSelectBaseDocument(true);
                                                                }}
                                                                disabled={onlyRead}
                                                            />
                                                        </FlexRow>
                                                        <FlexRow wrap>
                                                            <CheckBox
                                                                defaultChecked={disposalGismtForUnscannedLotsMode}
                                                                onChanged={(value) => updateDisposalGismtForUnscannedLotsMode(value)}
                                                                label={t("documents.movement.disposalGismtForUnscannedLots")}
                                                                disabled={!disposalGismtForUnscannedLotsModeEnabled || onlyRead}
                                                                clues={[t("documents.movement.clueTextDisposalGismtForUnscannedLots")]}
                                                            />
                                                            <CheckBox
                                                                onChanged={(value) => setData({ ...data, isNewBarcode: value })}
                                                                label={`Формировать\u00a0новый\u00a0штрих\u00a0код`}
                                                                disabled={onlyRead}
                                                            />
                                                        </FlexRow>
                                                    </Accordion>
                                                    <Accordion opened={false} id={`MovementComment-${props.idGlobal}`} caption="Комментарий">
                                                        <TextAreaInput
                                                            disabled={onlyRead}
                                                            placeholder="Напишите комментарий"
                                                            value={data.userComment ?? ""}
                                                            onChange={(value) => setData((currentData) => ({ ...currentData, userComment: value }))}
                                                        />
                                                    </Accordion>
                                                </Accordion>
                                        </>
                                    )}
                                    <FlexRow className={createMovementsStyles.field_flexblock}>
                                        <PositionEditPanel
                                            kiz={{
                                                onClick: () => setKizScanModal(true),
                                                disabled: kizDisabled(),
                                            }}
                                            edit={{
                                                onClick: () => {
                                                    if (selectedItem) {
                                                        const editItem = data.items.find((x) => x.idGlobal === selectedItem.idGlobal) as IMovementItemCreateDTO;
                                                        lotDP.getById(editItem.idLotFromGlobal, (item: ILotDTO) => {
                                                            setCreatorItem({
                                                                show: true,
                                                                item: item,
                                                                editItem: editItem,
                                                            });
                                                        });
                                                    }
                                                },
                                                disabled: selectedItem && !onlyRead ? false : true,
                                            }}
                                            delete={{
                                                onClick: () => {
                                                    if (selectedItem) {
                                                        let item = data.items.find((x) => x.idGlobal === selectedItem.idGlobal);
                                                        if (item) {
                                                            operativeReserve.delete(
                                                                {
                                                                    idLot: item.idLotFromGlobal,
                                                                    idTable: IdTableVariant.Movement,
                                                                    idDocument: data.idGlobal as string,
                                                                    idDocumentItem: item.idGlobal,
                                                                },
                                                                () => {
                                                                    setData({ ...data, items: data.items.filter((x) => x.idGlobal !== selectedItem.idGlobal) });
                                                                    setDisplayItems([...displayItems.filter((x) => x.idGlobal !== selectedItem.idGlobal)]);

                                                                    const itemsValid = itemsValidation.filter((item) => item.idGlobal !== selectedItem?.idGlobal);
                                                                    const itemsFilterValid = itemsFilter.filter((item) => item.idItem !== selectedItem?.idGlobal);
                                                                    setItemsValidation(itemsValid)
                                                                    setItemsFilter(itemsFilterValid)
                                                                    // setSelectedItem(undefined);
                                                                }
                                                            );
                                                        }
                                                    }
                                                },
                                                disabled: selectedItem && onlyRead,
                                            }}
                                        />
                                        <GridSelectorInput
                                            disabled={onlyRead}
                                            barcodeScan={tabsContext.currentTab && tabsContext.currentTab?.id === currentIdTab.current && !kizScanModal}
                                            gridFilter={lotGridFilter}
                                            dispatchGridFilter={dispatchLotGridFilter}
                                            selectorModalJsx={LotsSelectorModal}
                                            className={createMovementsStyles.field_SelectionLot}
                                            id={"inputAccompanyingSelectionGoods"}
                                            inline={true}
                                            label={t("documents.invoice.selectionOfGoods")}
                                            onSelect={handleLotSelect}
                                            onClear={() => {}}
                                            searchOption={searchOption.value}
                                            setScanData={setScanData}
                                            onChange={setScanData}
                                            idTable={IdTableVariant.Movement}
                                            activateGroupProcessing
                                            lastSearchQuerySettings = {lastSearchQuerySettings}
                                            autoFocus={showLastSearchQuery}
                                            key={selectedItem?.idGlobal}
                                            idStoreGlobal={data.idStoreFromGlobal}
                                        />
                                        <Select
                                            disabled={onlyRead}
                                            barcodeScan={tabsContext.currentTab && tabsContext.currentTab?.id === currentIdTab.current}
                                            onSelect={(option) => {
                                                setSearchOption(option);
                                            }}
                                            defaultOption={defaultSearchOption}
                                            value={searchOption}
                                            className={styles.field_SelectBlock}
                                            options={[
                                                {
                                                    displayName: t("documents.movement.goodsName"),
                                                    value: SearchOption.goodsName,
                                                },
                                                {
                                                    displayName: t("documents.movement.kizOrKizBox"),
                                                    value: SearchOption.kizOrKizBox,
                                                },
                                                {
                                                    displayName: t("documents.movement.goodsCodeBylot"),
                                                    value: SearchOption.goodsCodeBylot,
                                                },
                                                {
                                                    displayName: t("documents.movement.internalBarcode"),
                                                    value: SearchOption.internalBarcode,
                                                },
                                                {
                                                    displayName: t("documents.movement.gtinSgtin"),
                                                    value: SearchOption.gtinSgtin,
                                                },
                                            ]}
                                        />
                                    </FlexRow>

                                    <div className={styles.gridWrapper}>
                                        <div className={styles.masterGrid}>
                                            <ChangeableGrid
                                                documentStateProc={onlyRead ? !props.document?.isCrosspharmacy : false}
                                                autoSelect={autoSelectEnabled}
                                                gridId={uuidv4()}
                                                data={displayItems}
                                                documentType={DocumentType.movement}
                                                filter={gridFilter}
                                                totalCount={totalCount}
                                                plugin={MovementItemsGridPluginSettings}
                                                selectedItem={selectedItem}
                                                autoHighlightOnChange
                                                itemsFilter={itemsFilter}
                                                itemsValidation={itemsValidation}
                                                setItemsValidation={(value) =>{
                                                    const newItemsValidation = itemsValidation.map((item) => (item.idGlobal === value[0].idGlobal ? { ...item, ...value } : item))
                                                    setItemsValidation(newItemsValidation)
                                                }}
                                                getStyleCell={(cell, cells) => {
                                                    if (cell.propertyName === "lineStatus") {
                                                        const value = cell.value as string;
                                                        return `${changeableGridStyles.statusCell} ${changeableGridStyles[`statusCell_${value}`]}`;
                                                    }
                                                    return getStyleCell(cell, cells, DocumentType.movement);
                                                }}
                                                renderCustomCell={(cell) => {
                                                    if (cell.propertyName === "lineStatus") {
                                                        return <InvoiceStatusCell status={cell.value as string} />;
                                                    }
                                                    return null;
                                                }}
                                                onSelect={(row) => {
                                                    setAutoSelectEnabled(true);
                                                    setSelectedItem(row);
                                                }}
                                                onClick={(row) => {
                                                    setAutoSelectEnabled(true);
                                                    setSelectedItem(row);
                                                }}
                                                onSort={(i) => {
                                                    dispatchGridFilter({
                                                        type: "sort",
                                                        payload: i.propertyName,
                                                    });
                                                }}
                                                onFilterDelete={(i) =>
                                                    dispatchGridFilter({
                                                        type: "deleteColumnFilter",
                                                        payload: i.propertyName,
                                                    })
                                                }
                                                onPageNumberChange={(n) => {
                                                    dispatchGridFilter({
                                                        type: "changePageNumber",
                                                        payload: { pageNumber: n },
                                                    });
                                                }}
                                                onNumberPerPageChange={(n) => {
                                                    dispatchGridFilter({
                                                        type: "changeNumberPerPage",
                                                        payload: { numberPerPage: n },
                                                    });
                                                }}
                                                onColumnEnter={(value: IChangeDataGrid) => clearTimer(() => calcRow(value))}
                                                onChangeData={(value: IChangeDataGrid) => setTimer(() => calcRow(value))}
                                                searching
                                                isCrosspharmacy={onlyRead ? props.document?.isCrosspharmacy : false}
                                                isDocumentProcess={props.document?.documentState === 'proc'}
                                                customKizControl={(item: IChangeableGridRow) => {

                                                    if (!contractorFrom || 
                                                        !contractorTo || 
                                                        contractorFrom.idGlobal !== contractorTo.idGlobal)
                                                        return true;
                                                        
                                                    if (!requiredScanKiz) return true;

                                                    const countKizScan: number = item.countKizScan;
                                                    const quantity: number = item?.quantity;
                                                    const numerator: number = item.numerator;
                                                    const denominator: number = item.denominator;

                                                    if (numerator < denominator) {
                                                        if (countKizScan !== 1) {
                                                            return false;
                                                        } else {
                                                            return true;
                                                        }
                                                    } else {
                                                        if ((countKizScan !== quantity)) {
                                                            return false;
                                                        } else {
                                                            return true;
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>

                        <Accordion opened={false} caption={``} id={`MovementTo-${uuidv4()}`} bold documentSticky>
                            <GridWrapper cols={3}>
                                <MoneyFormatComponent label="Сумма без НДС, пост." inline value={supplierCostInfo?.sum} />
                                <MoneyFormatComponent label="Сумма НДС, пост." inline value={supplierCostInfo?.vatSum} />
                                <MoneyFormatComponent label="Сумма с НДС, пост." inline value={supplierCostInfo?.sumIncVat} />
                            </GridWrapper>
                            <GridWrapper cols={3}>
                                <MoneyFormatComponent label="Сумма без НДС, розн." inline value={retailCostInfo?.sum} />
                                <MoneyFormatComponent label="Сумма НДС, розн." inline value={retailCostInfo?.vatSum} />
                                <MoneyFormatComponent label="Сумма с НДС, розн." inline value={retailCostInfo?.sumIncVat} />
                            </GridWrapper>
                        </Accordion>
                    </div>
                </div>

                {kizScanModal && selectedScalingRatio && (
                    <KizScanModal
                        documentType={DocumentType.movement}
                        ok={(value, scalingRatio: IScalingRatioDTO) => {
                            let items = data.items.filter((x) => x.idGlobal !== selectedItem?.idGlobal);
                            setData({ ...data, items: items ? [...items, {...value, dateCreated: DateTime.now()}] : [value] });
                            setDisplayItems(
                                displayItems.map((x): IDisplayItem => {
                                    return {
                                        ...x,
                                        countKizScan: x.idGlobal === value.idGlobal ? countKizSum(value) : x.countKizScan,
                                        dateCreated: x.idGlobal === value.idGlobal ? DateTime.now() : x.dateCreated,
                                    };
                                })
                            );
                            setKizScanModal(false);
                        }}
                        cancel={() => {
                            setKizScanModal(false);
                        }}
                        onValidateDuplicate={(barcode,kiz,kizBoxes,kizOsuDtos) => validateDuplicateKizs(data.items,barcode,DocumentType.movement,kiz,kizBoxes,kizOsuDtos)}
                        document={{ idTable: IdTableVariant.Movement, idDocument: data.idGlobal as string }}
                        idLotFrom={selectedItemCreateDto?.idLotFromGlobal ?? null}
                        selectedItem={selectedItemCreateDto as IMovementItemEditDTO}
                        numerator={selectedScalingRatio.numerator}
                        scalingRatio={selectedScalingRatio}
                        gisMtOnlyMode={disposalGismtForUnscannedLotsMode}
                    />
                )}

                {creatorItem.show && creatorItem.item && !creatorItem?.editItem &&(
                    <MovementCreatorItemModal
                        idDocumentGlobal={data.idGlobal as string}
                        idDocumentItemGlobal={creatorItem.editItem?.idGlobal ?? uuidv4()}
                        isWithdrawalGismtForUnscannedLots={disposalGismtForUnscannedLotsMode}
                        lot={creatorItem.item}
                        items={data.items}
                        scanData={scanData}
                        ok={(createItem: ICreateItem) => {
                            let filteredItems: IMovementItemCreateDTO[] = data.items.filter((x) => x.idLotFromGlobal !== createItem.item.idLotFromGlobal);
                            let filteredDisplayItems: IDisplayItem[] = displayItems.filter((x) => x.idLotFromGlobal !== createItem.item.idLotFromGlobal);
                            setData({ ...data, items: [...filteredItems, createItem.item] });
                            setDisplayItems([...filteredDisplayItems, {...createItem.displayItem, 
                                supplierFrom: baseFields.contractorFrom.displayName,
                                supplierTo: baseFields.contractorTo.displayName,
                                isKiz: createItem.item.isKiz as boolean
                            },]);
                            setItemsFilter([...itemsFilter, createItem.filter]);
                            setItemsValidation([...itemsValidation, { idGlobal: createItem.item.idGlobal, message: "", err: false }]);
                            setCreatorItem({ show: false, item: null });
                            setBaseFields({ ...baseFields, storeFromLot: creatorItem.item?.store as IEntitySimpleDTO });

                            const newRow: IGridRow = {
                                idGlobal: createItem.displayItem.idGlobal,
                                displayName: createItem.displayItem.goodsName,
                                cells: [],
                                isDeleted: false,
                                isSelected: true,
                            };
                            setAutoSelectEnabled(false);
                            setSelectedItem(newRow);
                        }}
                        cancel={() => setCreatorItem({ show: false, item: null })}
                    />
                )}

                {creatorItem.show && creatorItem.item && creatorItem?.editItem && (
                    <MovementUpdateItemModal
                        lot={creatorItem.item}
                        kizCount={displayItems.find((x) => x.idGlobal === selectedItem?.idGlobal)?.countKizScan as number}
                        idDocumentGlobal={data.idGlobal as string}
                        idDocumentItemGlobal={creatorItem.editItem?.idGlobal}
                        movementItemEdit={creatorItem.editItem}
                        isWithdrawalGismtForUnscannedLots={disposalGismtForUnscannedLotsMode}
                        ok={(createItem: ICreateItem) => {
                            setData({ ...data, items: [...data.items.filter((x) => x.idGlobal !== createItem.item.idGlobal), createItem.item] });
                            setDisplayItems([...displayItems.filter((x) => x.idGlobal !== createItem.displayItem.idGlobal), {...createItem.displayItem,
                                supplierFrom: baseFields.contractorFrom.displayName,
                                supplierTo: baseFields.contractorTo.displayName,
                                isKiz: createItem.item.isKiz as boolean
                            }]);
                            setCreatorItem({ show: false, item: null });
                            setBaseFields({ ...baseFields, storeFromLot: creatorItem.item?.store as IEntitySimpleDTO });
                        }}
                        cancel={() => setCreatorItem({ show: false, item: null, editItem: null })}
                    />
                )}

                {lotsViewItem.item && lotsViewItem.show && (
                    <LotsSimpleSelectorModal
                        ok={(value: IEntitySimpleDTO) => {
                            
                            // Подгрузка ILotDTO уже идёт внутри обработчика для данного документа
                            if (lotsViewItem.handleLot) {
                                lotsViewItem.handleLot(value, lotsViewItem.queryArg);
                            }
                            else {
                                lotDP.getById(value.idGlobal, (lotDto: ILotDTO) => {
                                    setCreatorItem({ show: true, item: lotDto });
                                });
                            }
                        }}
                        cancel={() => setLotsViewItem({ item: lotsViewItem.item, show: false, multiple: true })}
                        data={lotsViewItem.item}
                    />
                )}

                {showMessageModal.show && (
                    <MessageModalWindow
                        message={showMessageModal.message}
                        ok={{
                            onClick: () => {
                                setShowMessageModal({ show: false, message: "" });
                                showMessageModal.btSaveOrOk === "ok" ? onOkAction() : props.save(data);
                            },
                        }}
                        cancel={{
                            onClick: () => {
                                setShowMessageModal({ show: false, message: "" });
                            },
                        }}
                        primary
                    />
                )}

                {showMessageModalValidDocument.show && (
                    <MessageModalWindow
                        message={showMessageModalValidDocument.message}
                        ok={{
                            onClick: () => {
                                setShowMessageModalValidDocument({ show: false, message: "" });
                            },
                        }}
                        cancel={{ onClick: () => setShowMessageModalValidDocument({ show: false, message: "" }) }}
                    />
                )}

                {showMessageModalActualQuantityChanged && 
                    <MessageModalWindow
                        message={t("Количество фактическое отличается от количества заявленого, необходимо отсканировать КИЗы полученных товаров")}
                        ok={{ onClick: () => {
                            setKizsKizBoxes([
                                ...kizsKizBoxes,
                                {
                                    idGlobal: data.items.find(element => element.idGlobal === selectedItem?.idGlobal)?.idGlobal,
                                    kizs: data.items.find(element => element.idGlobal === selectedItem?.idGlobal)?.kizs,
                                    kizBoxes: data.items.find(element => element.idGlobal === selectedItem?.idGlobal)?.kizBoxes
                                }
                            ])
                            setData({
                                ...data,
                                items: data.items.map(x => {
                                    if (x.idGlobal === selectedItem?.idGlobal) {
                                        return {
                                            ...x, 
                                            kizs: [],
                                            kizBoxes: []
                                        }
                                    } else {
                                        return {
                                            ...x
                                        }
                                    }                    
                                })
                            })
                            setDisplayItems([
                                ...displayItems.map((x) => {
                                    if (x.idGlobal === selectedItem?.idGlobal) {
                                        return {
                                            ...x, 
                                            countKizScan: 0
                                        }
                                    } else {
                                        return {
                                            ...x
                                        }
                                    }
                                }),
                            ]);

                            setShowMessageModalActualQuantityChanged(false)
                        } }}
                        cancel={{ onClick: () => {
                            setActualQuantity()
                            setShowMessageModalActualQuantityChanged(false)
                        } }}
                    />
                }

                {showMessageModalValidBaseDocument && 
                    <MessageModalWindow
                        message={t("errors.noStoreForBaseDocument")}
                        ok={{ onClick: () => setShowMessageModalValidBaseDocument(false) }}
                        cancel={{ onClick: () => setShowMessageModalValidBaseDocument(false) }}
                    />
                }

                {selectBaseDocument && (
                    <SelectDocumentModalWindow
                        isSkipLotSelection={isSkipLotSelection}
                        idStoreGlobal={data?.idStoreFromGlobal ?? uuidNull}
                        dateDocument={data.documentDate}
                        ok={(lots, document) => {
                            const values: IReturnCreatedItem[] = lots.map((x) => {
                                const idGlobal: string = uuidv4();
                                const actualQuantity = data.items.find((item) => item.idLotGlobal === x.idGlobal)?.actualQuantity
                                return {
                                    displayItem: {
                                        idGlobal: idGlobal,
                                        idDocumentGlobal: props.idGlobal,
                                        supplierVat: x.supplierCostInfo?.vat ?? 0,
                                        supplierPrice: x.supplierCostInfo?.price ?? 0,
                                        supplierVatPrice: x.supplierCostInfo?.vat ?? 0,
                                        supplierPriceIncVat: x.supplierCostInfo?.priceIncVat ?? 0,
                                        goodsCode: x.goodsCode,
                                        producer: x.producer?.displayName,
                                        supplierSum: x.supplierCostInfo?.sum ?? 0,
                                        supplierVatSum: x.supplierCostInfo?.vatSum ?? 0,
                                        supplierSumIncVat: x.supplierCostInfo?.sumIncVat ?? 0,
                                        supplierAdprice: x.supplierCostInfo.adprice,
                                        retailVat: x.retailCostInfo?.vat ?? 0,
                                        retailPrice: x.retailCostInfo?.price ?? 0,
                                        retailVatPrice: x.retailCostInfo?.vat ?? 0,
                                        retailPriceIncVat: x.retailCostInfo?.priceIncVat ?? 0,
                                        retailSum: x.retailCostInfo?.sum ?? 0,
                                        retailVatSum: x.retailCostInfo?.vat ?? 0,
                                        retailSumIncVat: x.retailCostInfo?.sumIncVat ?? 0,
                                        retailAdprice: x.retailCostInfo.adprice,
                                        goodsName: x.goods?.displayName,
                                        scalingRatioName: x.scalingRatio.displayName,
                                        quantity: x.actualQuantity,
                                        contractorPricePerUnit: 0,
                                        isKiz: x.isKiz,
                                        supplier: x.supplier,
                                        kizCount: x.isKiz === false ? undefined : 0,
                                        idLotGlobal: x.idGlobal,
                                        actualQuantity: actualQuantity
                                    },
                                    createdItem: {
                                        idGlobal: idGlobal,
                                        idGoodsGlobal: x.goods.idGlobal,
                                        idScalingRatioGlobal: x.scalingRatio.idGlobal,
                                        idLotGlobal: x.idGlobal,
                                        idLotFromGlobal: x.idGlobal,
                                        idSupplierGlobal: x.idSupplierGlobal,
                                        contractorPricePerUnit: 0,
                                        producerPrice: x.producerPrice,
                                        price: 0,
                                        priceVat: x.retailCostInfo?.vat ?? 0,
                                        vatSup: 0,
                                        isKiz: x.isKiz,
                                        retailCostInfo: x.retailCostInfo,
                                        supplierCostInfo: x.supplierCostInfo,
                                        kizs: [],
                                        kizBoxes: [],
                                        quantity: x.actualQuantity ?? 0,
                                        actualQuantity: actualQuantity
                                    },
                                };
                            });
                            setBaseDocument(document.displayName);
                            setDisplayItems(values.map((x) => x.displayItem));
                            setData({
                                ...data,
                                baseDocumentInfo: { idTable: document.idTable, idDocument: document.idGlobal },
                                items: values.map((x) => x.createdItem)
                            })
                            setSelectBaseDocument(false);
                        }}
                        cancel={{ onClick: () => setSelectBaseDocument(false) }}
                    />
                )}
                {сonfirmationItemsModalJsx}

                {checkKizState.showModal && checkKizState.results && checkKizState.results.length > 0 && (
                    <CheckKizResultsModalWindow
                    results={checkKizState.results}
                    onRemove={handleRemoveInvalidKizs}
                    onIgnore={handleIgnoreCheck}
                    isRemoving={checkKizState.isRemoving}
                />
                )}

                {checkKizState.isChecking && (
                    <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                    cursor: 'wait'
                    }}>
                    <Spinner xl />
                    </div>
                )}

            </BaseDocumentCreator>
        </>
    );
};
